import React from 'react';
import { ConfirmPositiveActionPopup } from 'features/nekst-widgets';
import { TeamSetupArea, useTeamSetupAreasService } from 'nekst-api';

export default function ActivateMarketForm(
  props: {
    teamSetupArea: TeamSetupArea,
  }
) {
  const teamSetupAreasService = useTeamSetupAreasService();

  return (
    <ConfirmPositiveActionPopup
      title="Restore Market"
      message={`Please confirm enabling this Market by clicking the "Activate" button below.`}
      submitFormFunc={async () => {
        await teamSetupAreasService.addSetupArea({
          setupAreaId: props.teamSetupArea.id,
          setupAreaVersion: props.teamSetupArea.versions[props.teamSetupArea.versions.length - 1].version,
        });
      }}
      buttonText="Activate"
    />
  );
}


export function ActivateProcessForm(
  props: {
    teamSetupArea: TeamSetupArea,
  }
) {
  const teamSetupAreasService = useTeamSetupAreasService();

  return (
    <ConfirmPositiveActionPopup
      title="Recover Custom Process"
      message={`Please confirm enabling this Custom Process by clicking the "Activate" button below.`}
      buttonText="Activate"
      submitFormFunc={async () => {
        await teamSetupAreasService.addSetupArea({
          setupAreaId: props.teamSetupArea.id,
          setupAreaVersion: props.teamSetupArea.versions[props.teamSetupArea.versions.length - 1].version,
        });
      }}
    />
  );
}
